import React from "react";
import "./MastersCard.css";

interface MastersCardProps {
  image: string;
  name: string;
  surname: string;
  credentials: string;
  description: string;
}

const MastersCard: React.FC<MastersCardProps> = ({
  image,
  name,
  surname,
  credentials,
  description,
}) => {
  return (
    <div
      className="masters-card"
      style={{ backgroundImage: `url(${image})`  
    }} // Use the image as a background
    >
      {/* Initial Overlay Content (Name and Credentials) */}
      <div className="masters-overlay">
        <h3 className="masters-name">{`${name} `}</h3>
        <h3 className="masters-name">{` ${surname}`}</h3>
        <p className="masters-credentials">{credentials}</p>
      </div>

      {/* Hover Overlay Content (Name and Description) */}
      <div className="masters-hover-overlay">
        <h3 className="masters-name">{`${name} ${surname}`}</h3>
        <p className="masters-description">{description}</p>
      </div>
    </div>
  );
};

export default MastersCard;
